import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import {useApplicationStore} from './ListOfPREditors.brick.jsx';
import {CheckboxWithOptionsListOfPREditors} from './CheckboxWithOptionsListOfPREditors.jsx';
import {COLUMN_HEADER_CONFIG} from '../utils/columnsConfig.jsx';
import {ColumnsButton} from './ColumnsButton.jsx';
import {useProperty} from '@olympeio/core';
import {BrickContext} from 'olympe';

/**
 * @param {ListOfPREditorsHeader.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function ListOfPREditorsHeader(props) {
    const columnsToDisplay = useApplicationStore((state) => state.columnsToDisplay);
    const setColumnsToDisplay = useApplicationStore((state) => state.setColumnsToDisplay);
    const openPRs = useProperty(props.context, 'Open PRs');

    const filteredHeaderConfig = useMemo(
        () => COLUMN_HEADER_CONFIG.filter((c) => !c.tab || c.tab(props.currentTab)),
        [props.currentTab],
    );


    const availableColumns = useMemo(
        () => filteredHeaderConfig.map((c) => c.name),
        [filteredHeaderConfig],
    );

    const columnsProps = useMemo(() => ({
        currentTab: props.currentTab,
        handleSort: props.handleSort,
        sortKey: props.sortKey,
        sortDirection: props.sortDirection,
        sortConfig: props.sortConfig,
    }), [
        props.currentTab,
        props.handleSort,
        props.sortKey,
        props.sortDirection,
        props.sortConfig.key,
        props.sortConfig.direction,
    ]);

    return (
        <div className={openPRs?.length > 0 || props.displayedRequests.length > 5 ? 'list-of-pr-header-fixed-expanded' : 'list-of-pr-header-fixed'}>
            <Grid
                container
                columns={24}
                sx={{
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: 1,
                    m: '0 auto',
                    pt: '5px',
                    pb: '5px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#676767',
                    textAlign: 'center',
                }}
            >
                <Grid item xs={0.4}>
                    <div style={{marginLeft: '-0.5rem'}}>
                        <CheckboxWithOptionsListOfPREditors
                            displayedRequests={props.displayedRequests}
                            selectedPRs={props.selectedPRs}
                            setSelectedPRs={props.setSelectedPRs}
                            setSelectPRsMode={props.setSelectPRsMode}
                            failedMassSubmittedPRs={props.failedMassSubmittedPRs}
                            setFailedMassSubmittedPRs={props.setFailedMassSubmittedPRs}
                            massSubmitLoading={props.massSubmitLoading}
                            massDeleteLoading={props.massDeleteLoading}
                            currentTab={props.currentTab}
                        />
                    </div>
                </Grid>

                {columnsToDisplay.map((name) => {
                    const config = filteredHeaderConfig.find((item) => item.name === name);
                    if (!config || (config.tab && !config.tab(props.currentTab))) return null;
                    return (
                        <Grid item xs={config.xs} sx={config.sx} key={name}>
                            {config.content(columnsProps)}
                        </Grid>
                    );
                })}

                <Grid item xs={1} sx={{textAlign: 'center'}}>
                    <ColumnsButton
                        context={props.context}
                        columnsToDisplay={columnsToDisplay}
                        setColumnsToDisplay={setColumnsToDisplay}
                        availableColumns={availableColumns}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

ListOfPREditorsHeader.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    currentTab: PropTypes.string,
    handleSort: PropTypes.func,
    sortKey: PropTypes.object,
    sortDirection: PropTypes.object,
    sortConfig: PropTypes.object,
    displayedRequests: PropTypes.array,
    selectedPRs: PropTypes.array,
    setSelectedPRs: PropTypes.func,
    setSelectPRsMode: PropTypes.func,
    failedMassSubmittedPRs: PropTypes.array,
    setFailedMassSubmittedPRs: PropTypes.func,
    massSubmitLoading: PropTypes.bool,
    massDeleteLoading: PropTypes.bool,
};
